export default __webpack_public_path__ + "static/david-14e1ea0ce7754af88967cb06bb9b18d3.jpg";